import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileNavService, MobileTabConfig } from './mobile-nav.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mobile-bottom-nav',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-bottom-nav.component.html',
  styleUrls: ['./mobile-bottom-nav.component.css'],
})
export class MobileBottomNavComponent implements OnInit, OnDestroy {
  tabs: MobileTabConfig[] = [];
  activeTab: string = 'materials';
  pillOffset = 0;
  pillWidth = '16.667%';
  isVisible = true;
  badgeCounts: Record<string, number> = {};

  private subs: Subscription[] = [];

  constructor(private mobileNavService: MobileNavService) {}

  ngOnInit(): void {
    this.subs.push(
      this.mobileNavService.tabs.subscribe(tabs => {
        this.tabs = tabs;
        this.pillWidth = tabs.length > 0 ? `${100 / tabs.length}%` : '16.667%';
        this.updatePillPosition();
      }),
      this.mobileNavService.activeTab.subscribe(tab => {
        this.activeTab = tab;
        this.updatePillPosition();
      }),
      this.mobileNavService.navVisible.subscribe(v => this.isVisible = v),
      this.mobileNavService.badgeCounts.subscribe(counts => this.badgeCounts = counts),
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  selectTab(tab: string): void {
    this.mobileNavService.setActiveTab(tab);
  }

  getCount(key: string): number {
    return this.badgeCounts[key] ?? 0;
  }

  private updatePillPosition(): void {
    const idx = this.tabs.findIndex(t => t.key === this.activeTab);
    this.pillOffset = idx * 100;
  }
}
